import { createSlice } from "@reduxjs/toolkit";

interface UiState {
  onboardingOverlayHidden: boolean;
  appLoadingSkeletonVisible: boolean;
}

const initialState: UiState = {
  onboardingOverlayHidden: false,
  appLoadingSkeletonVisible: true,
};

const uiSlices = createSlice({
  name: "ui",
  initialState,
  reducers: {
    hideOnboardingOverlay(state) {
      state.onboardingOverlayHidden = true;
    },
    showOnboardingOverlay(state) {
      state.onboardingOverlayHidden = false;
    },
    hideAppLoadingSkeleton(state) {
      state.appLoadingSkeletonVisible = false;
    },
  },
});

export const { hideOnboardingOverlay, showOnboardingOverlay, hideAppLoadingSkeleton } = uiSlices.actions;

export default uiSlices;


